import { BURBANK_GEOID } from '../../eia861UtilityElectricity/bwpObservations';
import { BH_EXPERIMENT_GEOID } from './bhSourceControls';
import { buildBhElectricityCanonicalSeries, buildBhGasCanonicalSeries } from './buildCanonicalBhV2';
import {
  buildBurbankElectricityCanonicalSeries,
  buildBurbankGasCanonicalSeries,
} from './buildCanonicalBurbankEia861';
import type { BhExperimentLegacyContext } from './legacyContext';
import {
  BH_CAP_NONRESIDENTIAL_EXPERIMENT_V2_POLICY,
  BURBANK_EIA861_PILOT_POLICY,
  type CanonicalEnergyActivityYear,
  type ExperimentFuel,
} from './types';

export interface CanonicalEnergySeriesResult {
  policyId: string;
  geoid: string;
  fuel: ExperimentFuel;
  years: CanonicalEnergyActivityYear[];
}

export function buildCanonicalEnergyActivitySeries(
  policyId: string,
  geoid: string,
  fuel: ExperimentFuel,
  legacy: BhExperimentLegacyContext
): CanonicalEnergySeriesResult {
  if (policyId === BURBANK_EIA861_PILOT_POLICY) {
    if (geoid.replace(/^0+/, '') !== BURBANK_GEOID.replace(/^0+/, '')) {
      throw new Error(`Policy ${policyId} is only defined for GEOID ${BURBANK_GEOID}.`);
    }
    const years =
      fuel === 'electricity'
        ? buildBurbankElectricityCanonicalSeries(legacy)
        : buildBurbankGasCanonicalSeries(legacy);
    return { policyId, geoid, fuel, years };
  }

  if (policyId !== BH_CAP_NONRESIDENTIAL_EXPERIMENT_V2_POLICY) {
    throw new Error(`Unknown experiment policy: ${policyId}`);
  }
  if (geoid !== BH_EXPERIMENT_GEOID) {
    throw new Error(`Policy ${policyId} is only defined for GEOID ${BH_EXPERIMENT_GEOID}.`);
  }

  const years =
    fuel === 'electricity'
      ? buildBhElectricityCanonicalSeries(legacy)
      : buildBhGasCanonicalSeries(legacy);

  return { policyId, geoid, fuel, years };
}
